import RetailerItemsCount from './RetailerItemsCount'

export default RetailerItemsCount
